module.exports = __webpack_public_path__ + "media/images/online_talks/btn_cta-bd399eb4157e121bd6cbd204b9eda449.png";